var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYallaBidLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 50",
    width: 200,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yb logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ed4928 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m21.7 8h2.7v4.5q0 3.2-0.6 5.9-0.6 2.8-1.6 4.9-1 2-2.4 3.2-1.3 1.2-2.9 1.2h-2.3v10.7h-2.8v-10.7h-2.3q-1.5 0-2.9-1.2-1.4-1.2-2.4-3.2-1-2.1-1.6-4.9-0.6-2.7-0.6-5.9v-4.5h2.7v4.5q0 2 0.4 3.8 0.4 1.7 1 3.1 0.7 1.3 1.5 2 0.9 0.8 1.9 0.8h7.4q1 0 1.9-0.8 0.8-0.7 1.5-2 0.6-1.4 1-3.1 0.4-1.8 0.4-3.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m37.1 8h3.6l11.1 30.4h-3.4l-2.9-8.2h-13.1l-2.9 8.2h-3.4zm-2.7 16.7h9.1l-4.6-12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m59.9 32.9h18.4v5.5h-21.1v-30.4h2.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m85.3 32.9h18.3v5.5h-21v-30.4h2.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m119 8h3.6l11.1 30.4h-3.4l-2.9-8.2h-13.1l-3 8.2h-3.3zm-2.7 16.7h9l-4.5-12.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m155.9 8q0.9 0 1.7 0.7 0.8 0.7 1.4 1.9 0.6 1.3 1 2.9 0.3 1.6 0.3 3.5 0 1.8-0.3 3.4-0.4 1.6-0.9 2.8 0.5 1.2 0.9 2.8 0.3 1.6 0.3 3.4 0 1.8-0.3 3.5-0.4 1.6-1 2.8-0.6 1.2-1.4 1.9-0.8 0.8-1.7 0.8h-18v-30.4zm0 12.4q0.7 0 1.2-1 0.5-1 0.5-2.4 0-1.5-0.5-2.5-0.5-1-1.2-1h-15.3v6.9zm0 12.5q0.7 0 1.2-1.1 0.5-1 0.5-2.4 0-1.4-0.5-2.4-0.5-1-1.2-1h-15.2v6.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m165.7 8h2.7v30.4h-2.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m188.7 8q1.5 0 2.9 1.2 1.4 1.2 2.4 3.2 1 2.1 1.6 4.9 0.6 2.7 0.6 5.9 0 3.1-0.6 5.9-0.6 2.8-1.6 4.8-1 2.1-2.4 3.3-1.4 1.2-2.9 1.2h-14.9v-30.4zm0 24.9q1 0 1.8-0.8 0.9-0.8 1.5-2.1 0.7-1.3 1.1-3.1 0.3-1.7 0.3-3.7 0-2-0.3-3.8-0.4-1.7-1.1-3-0.6-1.4-1.5-2.1-0.8-0.8-1.8-0.8h-12.2v19.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYallaBidLogo);
export default __webpack_public_path__ + "static/media/YallaBid_Logo.0a65f59f3a842efc89bb685b1a9ddde2.svg";
export { ForwardRef as ReactComponent };